// test2341
(2341 && 0);
